/* eslint-disable no-restricted-globals */
import { observable, makeAutoObservable } from 'mobx';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { DateTime, TimezoneType } from 'src_common/utils/time/time';

export class HomePageCarouselDateState {
    public constructor(
        private readonly homePageCarouselState: HomePageCarouselState,
        private readonly timezone?: TimezoneType
    ) {
        makeAutoObservable(this);
    }
    @observable public startDateError = false;
    @observable public endDateError = false;

    public onChangeStartDate = (date: Date | null): void => {
        this.homePageCarouselState.dateFrom.setAsVisited();
        if (date !== null) {
            this.homePageCarouselState.dateFrom.setValue(date.toISOString());
        }
    };

    public onBlurStartDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        this.homePageCarouselState.dateFrom.setAsVisited();
        if (date.target.value === '') {
            this.startDateError = true;
        } else if (this.startDateError) {
            this.startDateError = false;
        }
    };

    public onChangeEndDate = (date: Date | null): void => {
        this.homePageCarouselState.dateTo.setAsVisited();
        if (date !== null) {
            this.homePageCarouselState.dateTo.setValue(date.toISOString());
        }
    };

    public onBlurEndDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        this.homePageCarouselState.dateTo.setAsVisited();
        if (date.target.value === '') {
            this.endDateError = true;
        } else if (this.endDateError) {
            this.endDateError = false;
        }
    };

    public preventDefault = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
    };

    private getOffsetHour = (date: DateTime): number => {
        if (this.timezone === undefined) {
            return 0;
        }

        const deviceTime = date;
        const configTime = date.tz(this.timezone);

        let deviceOffset: number;
        let configOffset: number;

        if (deviceTime.format().includes('Z')) {
            deviceOffset = 0;
        } else {
            deviceOffset = Number(deviceTime.format().slice(-6, -3));
        }

        if (configTime.format().includes('Z')) {
            configOffset = 0;
        } else {
            configOffset = Number(configTime.format().slice(-6, -3));
        }

        if (Number.isNaN(deviceOffset) || Number.isNaN(configOffset)) {
            throw Error(
                `adjust timezone error: deviceOffset: ${deviceOffset} and configOffset: ${configOffset} cannot be NaN`
            );
        }

        const offset = deviceOffset - configOffset;
        return offset;
    };

    public getDateWithOffset = (date: string): Date | null => {
        const dateTime = DateTime.from(date);

        if (date === '' || dateTime === null) {
            return null;
        }

        const offsetHour = this.getOffsetHour(dateTime);
        const newDate = dateTime.addHours(-offsetHour);

        return new Date(newDate.toISOString());
    };

    public get startDateWithOffset(): Date | null {
        return this.getDateWithOffset(this.homePageCarouselState.dateFrom.value);
    }

    public get endDateWithOffset(): Date | null {
        return this.getDateWithOffset(this.homePageCarouselState.dateTo.value);
    }
}
